import { FC } from "react";
import PageTemplate from "../PageTemplate";
import MainPage from "./MainPage";

const Main: FC = () => {
    return <PageTemplate Page={MainPage} noBreadcrumbs />;
};

export default Main;
